import { render, staticRenderFns } from "./c_radio.vue?vue&type=template&id=65949efe&scoped=true"
import script from "./c_radio.vue?vue&type=script&lang=js"
export * from "./c_radio.vue?vue&type=script&lang=js"
import style0 from "./c_radio.vue?vue&type=style&index=0&id=65949efe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65949efe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65949efe')) {
      api.createRecord('65949efe', component.options)
    } else {
      api.reload('65949efe', component.options)
    }
    module.hot.accept("./c_radio.vue?vue&type=template&id=65949efe&scoped=true", function () {
      api.rerender('65949efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_radio.vue"
export default component.exports